import React from "react";
import {differenceInDays, parseISO, startOfToday} from "date-fns";

import {Text} from "@pg-design/text-module";

import {actualStreetNameCheck} from "../../../property/helpers/generated_decription/generated_description";
import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {OfferType} from "../../types/OfferType";
import {OfferDetailGeneratedDescriptionCommercial} from "./OfferDetailGeneratedDescriptionCommercial";
import {OfferDetailGeneratedDescriptionFlat} from "./OfferDetailGeneratedDescriptionFlat";
import {OfferDetailGeneratedDescriptionHouse} from "./OfferDetailGeneratedDescriptionHouse";

interface IProps {
    className?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        currency: Currency;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        region: {
            name_declension_where: string;
        };
        stats: {
            all_flat_types: Record<string, number>;
            all_house_types: Record<string, number>;
            distance_from_region: {
                center: boolean;
                region: string;
                distance: number;
            };
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        street_name: string;
        street_number: string | null;
        type: OfferType;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export interface IRoomRange {
    area: {
        min: number;
        max: number;
    };
    count: number;
    price: {
        min: number;
        max: number;
    };
}

export const OfferDetailGeneratedDescription = (props: IProps) => {
    const {offer} = props;
    const today = startOfToday();
    const upper = parseISO(offer.construction_date_range.upper);
    const diff = differenceInDays(today, upper);
    const doesOfferHaveRealStreet = actualStreetNameCheck(offer.street_name);
    const showStreetName: boolean = !!offer.street_name && doesOfferHaveRealStreet;
    const textAfterInvestorOrVendorName = `${offer.investor || offer.vendor.name}`.endsWith(".") ? "" : ".";

    const genericDescription = `Inwestycja ${offer.name} znajduje się ${offer.region.name_declension_where}${showStreetName ? ", " : " "} ${
        showStreetName ? `${offer.street_name} ${offer.street_number || ""}` : ""
    } ${
        offer.stats?.distance_from_region && offer.stats.distance_from_region.distance > 0
            ? ` (${offer.stats.distance_from_region.distance} km od ${offer.stats.distance_from_region.center ? `centrum` : ""} ${
                  offer.stats.distance_from_region.region
              }),`
            : ""
    } ${
        offer.vendor.type === VendorType.DEVELOPER
            ? `${diff <= 0 ? "jest realizowana" : "została zrealizowana"} przez ${offer.investor ?? offer.vendor.name}${textAfterInvestorOrVendorName}`
            : offer.vendor.type === VendorType.AGENCY
              ? ` sprzedaż prowadzi ${offer.vendor.name}${textAfterInvestorOrVendorName}`
              : ""
    }`;

    return (
        <Text variant="body_copy_1" as="div">
            <p>{genericDescription}</p>
            {offer.type === OfferType.FLAT && <OfferDetailGeneratedDescriptionFlat offer={offer} />}
            {offer.type === OfferType.HOUSE && <OfferDetailGeneratedDescriptionHouse offer={offer} />}
            {offer.type === OfferType.COMMERCIAL && <OfferDetailGeneratedDescriptionCommercial offer={offer} />}
        </Text>
    );
};
import React from "react";
import {differenceInDays, parseISO, startOfToday} from "date-fns";

import {Text} from "@pg-design/text-module";

import {actualStreetNameCheck} from "../../../property/helpers/generated_decription/generated_description";
import {IParkingPlace} from "../../../property/interfaces/IParkingPlace";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {Currency} from "../../../types/Currency";
import {VendorType} from "../../../vendor/helpers/VendorType";
import {OfferType} from "../../types/OfferType";
import {OfferDetailGeneratedDescriptionCommercial} from "./OfferDetailGeneratedDescriptionCommercial";
import {OfferDetailGeneratedDescriptionFlat} from "./OfferDetailGeneratedDescriptionFlat";
import {OfferDetailGeneratedDescriptionHouse} from "./OfferDetailGeneratedDescriptionHouse";

interface IProps {
    className?: string;
    offer: {
        buildings: number;
        construction_date_range: IRangeQuery<string>;
        currency: Currency;
        floors_above_ground_range: IRangeQuery<number> | null;
        floors_below_ground: number | null;
        investor: string | null;
        is_holiday_location: boolean;
        is_condohotel: boolean;
        name: string;
        parking_places: IParkingPlace[];
        properties: number;
        region: {
            name_declension_where: string;
        };
        stats: {
            all_flat_types: Record<string, number>;
            all_house_types: Record<string, number>;
            distance_from_region: {
                center: boolean;
                region: string;
                distance: number;
            };
            properties_count_for_sale: number;
            properties_count_mdm: number;
            properties_with_roi_count: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_m2_min: number;
            ranges_price_m2_max: number;
            ranges_price_min: number;
            rooms_ranges: IRoomRange[];
        } | null;
        storage: {
            quantity: number;
            description: string;
            price: number;
        };
        street_name: string;
        street_number: string | null;
        type: OfferType;
        vendor: {
            type: VendorType;
            name: string;
        };
    };
}

export interface IRoomRange {
    area: {
        min: number;
        max: number;
    };
    count: number;
    price: {
        min: number;
        max: number;
    };
}

export const OfferDetailGeneratedDescription = (props: IProps) => {
    const {offer} = props;
    const today = startOfToday();
    const upper = parseISO(offer.construction_date_range.upper);
    const diff = differenceInDays(today, upper);
    const doesOfferHaveRealStreet = actualStreetNameCheck(offer.street_name);
    const showStreetName: boolean = !!offer.street_name && doesOfferHaveRealStreet;
    const textAfterInvestorOrVendorName = `${offer.investor || offer.vendor.name}`.endsWith(".") ? "" : ".";

    const genericDescription = `Inwestycja ${offer.name} znajduje się ${offer.region.name_declension_where}${showStreetName ? ", " : " "} ${
        showStreetName ? `${offer.street_name} ${offer.street_number || ""}` : ""
    } ${
        offer.stats?.distance_from_region && offer.stats.distance_from_region.distance > 0
            ? ` (${offer.stats.distance_from_region.distance} km od ${offer.stats.distance_from_region.center ? `centrum` : ""} ${
                  offer.stats.distance_from_region.region
              }),`
            : ""
    } ${
        offer.vendor.type === VendorType.DEVELOPER
            ? `${diff <= 0 ? "jest realizowana" : "została zrealizowana"} przez ${offer.investor ?? offer.vendor.name}${textAfterInvestorOrVendorName}`
            : offer.vendor.type === VendorType.AGENCY
              ? ` sprzedaż prowadzi ${offer.vendor.name}${textAfterInvestorOrVendorName}`
              : ""
    }`;

    return (
        <Text variant="body_copy_1" as="div">
            <p>{genericDescription}</p>
            {offer.type === OfferType.FLAT && <OfferDetailGeneratedDescriptionFlat offer={offer} />}
            {offer.type === OfferType.HOUSE && <OfferDetailGeneratedDescriptionHouse offer={offer} />}
            {offer.type === OfferType.COMMERCIAL && <OfferDetailGeneratedDescriptionCommercial offer={offer} />}
        </Text>
    );
};
